const convertToInternationalNumber = (phoneNumber : string, internationalDiallingCode : number = 44) : string => {
  if (!phoneNumber) {
    return phoneNumber;
  }
  let convertedNumber = phoneNumber.replaceAll(" ", "");
  if (convertedNumber.startsWith("0")) {
    convertedNumber = convertedNumber.substring(1);
  }

  return `+${internationalDiallingCode}${convertedNumber}`;
};

const stripInternationalDiallingCode = (phoneNumber : string) : string => {
  if (!phoneNumber || phoneNumber.length === 0) {
    return phoneNumber;
  }

  let convertedNumber = phoneNumber.replaceAll(" ", "");

  if (convertedNumber.length === 0) {
    return convertedNumber;
  }

  if (convertedNumber.startsWith("+")) {
    convertedNumber = convertedNumber.substring(3);
  }

  return convertedNumber;
};

export { convertToInternationalNumber, stripInternationalDiallingCode };
